import React, { useEffect, useState, useRef } from "react";
import { smoothScroll } from "../../utils/scrollbarUtil";
import Content from "../content/Content";
import { cleanJoin } from "../../utils/stringUtil";
import { isMobile } from "../../utils/screenUtil";

function Tabs({
  prefix = "t",
  scrollToSection = true,
  activeTab,
  setActiveTab,
  tabsClassName = "",
  scrollableContentClassName = "",
  scrollableContentHeight,
  children,
}) {
  useEffect(() => {
    if (scrollToSection) {
      smoothScroll(`#${prefix}${activeTab}`);
    }
  }, [activeTab, prefix, scrollToSection]);

  const [isSticky, setIsSticky] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    const header = headerRef?.current;
    const observer = new IntersectionObserver(
      ([e]) => {
        setIsSticky(e.isIntersecting);
      },
      { threshold: [0.1, 1] }
    );

    if (header) {
      observer.observe(header);
    }

    return () => {
      observer.unobserve(header);
    };
  }, [headerRef]);

  return (
    <div>
      <div
        className={cleanJoin(
          "tabs is-medium is-centered is-fullwidth",
          isMobile() ? "scrollbar-no-width" : "",
          tabsClassName
        )}
        data-testid="tabsNav"
        id="tabsNav"
        ref={headerRef}
        style={
          isSticky === false
            ? {
                position: "sticky",
                width: "100%",
              }
            : children.length <= 1
            ? { top: 0, visibility: "hidden" }
            : { top: 0 }
        }
      >
        <ul
          className="mt-0 ml-0 p-1"
          style={children.length <= 1 ? { visibility: "hidden" } : { visibility: "visible" }}
        >
          {children.map((child, index) => {
            if (children.length <= 1) {
              return null;
            } else {
              return (
                <li key={prefix + index} className={index === activeTab ? "is-active" : ""}>
                  <a id={`linktab-` + index} onClick={() => setActiveTab(index)}>
                    {child.props.label}
                  </a>
                </li>
              );
            }
          })}
        </ul>
      </div>
      <Content className={scrollableContentClassName} height={scrollableContentHeight}>
        {children.map((child, index) => (
          <section
            key={prefix + index}
            id={prefix + index}
            className={cleanJoin(
              "section",
              child.props.className,
              scrollToSection ? "" : activeTab === index ? "" : "is-hidden"
            )}
          >
            {child}
          </section>
        ))}
      </Content>
    </div>
  );
}

export default Tabs;
